// src/App.js
import React from 'react';
import GoldTransactionTable from './GoldTransactionTable';
// import { CssBaseline, Container } from '@mui/material';

function App() {
    return (
        <GoldTransactionTable />

    );
}

export default App;